exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-barrierefreiheit-js": () => import("./../../../src/pages/barrierefreiheit.js" /* webpackChunkName: "component---src-pages-barrierefreiheit-js" */),
  "component---src-pages-imprint-js": () => import("./../../../src/pages/Imprint.js" /* webpackChunkName: "component---src-pages-imprint-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

